import React from 'react'
import 'styles/index.scss'
import 'semantic/dist/semantic.css'

import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import createHistory from 'history/createBrowserHistory'

import Routes from 'routes'
import createStore from 'store/create'

const history = createHistory()
const store = createStore(history)

export default () => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Routes />
    </ConnectedRouter>
  </Provider>
)



// WEBPACK FOOTER //
// ./src/App.js